import Checkbox from '../../../Checkbox';

import styles from './_index.module.scss';

export interface MultiOptionProps {
  data: object;
  isSelected: boolean;
  label: React.ReactNode;
  selectOption: () => void;
}

const MultiOption = ({ data, isSelected, label, selectOption }: MultiOptionProps) => {
  return (
    <div className={styles['multi-option']}>
      <Checkbox isChecked={isSelected} label={label} onChange={selectOption} value={data} />
    </div>
  );
};

export default MultiOption;
